type RequestState = {
  _apiEndpoint: string;
  _apiVersion: string;
  _enabled: boolean;
  _hasConnection: boolean;
  _simulateBadNetwork: boolean;
  accessToken: null | string;
  accessTokenExpires: number;
  id: number;
};

export const requestState: RequestState = {
  _apiEndpoint: 'localhost',
  _apiVersion: '1.0',
  _enabled: true,
  _hasConnection: true,
  _simulateBadNetwork: false,
  accessToken: null,
  accessTokenExpires: 0,
  id: 0,
};
